import axios from "axios";

import {
  reducerUsersFilters,
  reducerGetUsersList,
  reducerGetAllUsersList,
  reducerGetRoles
} from "../../reducer/accessRights/reducers/usersList";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetEmployeesList =
  () =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      const response = await axios.get(`${BASE_URL}/json/auth/employee/list`);
      dispatch(reducerGetUsersList(response.data));
    };

export const actionTableEmployeesList =
  (limit: number, offset: number, visible: boolean) =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      const store = getState();
      const filter = store.roles.usersList.userInputValues;

      try {
        const response = await axios.post(`${BASE_URL}/json/auth/employees/list-employees`, {
          pageNumber: offset,
          pageSize: limit,
          visibleInPersonalClaims: visible,
          ...filter
        });
        if (visible) {
          dispatch(reducerGetUsersList(response.data));
          return response.data.data;
        } else {
          dispatch(reducerGetAllUsersList(response.data));
        }
      } catch {
        console.log('err');
      }
    };

export const actionEditVisibleEmployees =
  (idArr: { id: number }[], visible: boolean) =>
    async (dispatch: AppDispatch) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      const ids = idArr && idArr.map((obj: { id: number }) => obj.id);
      if (idArr.length > 0) {
        const response = await axios.post(`${BASE_URL}/json/auth/employees/visible-in-personal-claims`, {
          ids: ids,
          visible: visible
        });
        console.log(response);
      }
    };

export const actionGetRoles = () => async (dispatch: AppDispatch) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  try {
    const response = await axios.get(`${BASE_URL}/json/auth/roles`);
    dispatch(reducerGetRoles(response.data));
  } catch (err: any) {
    if (err.response.status === 401) {
      window.location.href = "/login";
    }
  }
};

export const actionGetEmployeesFiltersLogin =
  () => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(
        `${BASE_URL}/json/auth/employees/ref-filters/logins`
      );
      dispatch(reducerUsersFilters({ ...{ logins: response.data } }));
    } catch (err) { }
  };

export const actionGetEmployeesFiltersRoles =
  () => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(
        `${BASE_URL}/json/auth/employees/ref-filters/roles`
      );

      dispatch(reducerUsersFilters({ ...{ roles: response.data } })); 
    } catch {
      console.log('err');
    }
  };

export const actionEmployeesDeleteClaims =
  (id: number | null, data: { id: number, name: string }[]) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.delete(
        `${BASE_URL}/json/auth/employees/delete-claims`,
        {
          data: {
            employeeId: id,
            claims: data
          }
        }
      );
      return response; 
    } catch {
      console.log('err');
    }
  };

export const actionEmployeesSetClaims =
  (id: number, data: { id: number, name: string }) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.patch(
        `${BASE_URL}/json/auth/employees/set-claims?employeeId=${id}`, data
      );
      if (response.status === 200) {
        return data;
      } 
    } catch {
      console.log('err');
    }
  };

export const actionEmployeesGetByLogin =
  (data: string) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.post(
        `${BASE_URL}/json/auth/employees/get-by-login`, data
      );
      console.log(response); 
    } catch {
      console.log('err');
    }
  };
